import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const hasText = input => input.text != ''

const oeqValidationSelector = createSelector(
	[state => state.oeq],
	oeqState => {
		const questions = oeqState.questions
		const hasExceedChars = questions.some(question => question.hasExceedChars)
		const valid = !hasExceedChars && questions.every(hasText)

		return {
			valid,
			message: valid ? null : (hasExceedChars ? localize('global_review_information_error') : localize('quiz_complete_fields')),
		}
	}
)

export default oeqValidationSelector
